module.exports = __webpack_public_path__ + "static/chemical-free-13425f596f60ef0826612712540f8980.jpg";